export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetToken(context) {
      context.commit("updateToken", false)
    },
  },
  mutations: {
    updateToken(state, data) {
      return state.data = data
    }
  }
}